import { connect as adFoxConnect } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';

export const AdFoxBanner = adFoxConnect(AdFoxTemplates);
